import { useEffect, useRef } from "react";
import { ensurePushPermissionAndToken, onForegroundPush } from "../services/push";

/**
 * Componente invisible que:
 *  - pide permiso de notificaciones (si no lo tiene),
 *  - obtiene el token FCM,
 *  - lo guarda en Firestore: tenants/{tenantId}/users/{uid}/fcmTokens/{token}
 *  - opcional: escucha notificaciones en foreground (log)
 */
export default function PushRegistrar({
  tenantId,
  uid,
  log = false,
}: {
  tenantId: string;
  uid: string;
  log?: boolean;
}) {
  const ranRef = useRef(false);

  useEffect(() => {
    if (!tenantId || !uid) return;
    if (ranRef.current) return; // evitar doble ejecución en StrictMode dev
    ranRef.current = true;

    ensurePushPermissionAndToken(tenantId, uid)
      .then((token) => {
        if (log) console.info("[push] token", token);
      })
      .catch((err) => console.error("[push] error", err));

    // opcional: ver notificaciones cuando la app está en foreground
    if (log) {
      onForegroundPush((p) => {
        console.info("[push] foreground payload:", p);
      });
    }
  }, [tenantId, uid, log]);

  return null; // no renderiza nada
}
